export default __webpack_public_path__ + "static/media/logo.c6cd23b0.png";